<template>
  <collapsible-widget
    title="PODKŁADY MAPOWE"
    :maxHeight="30"
    :expand-widget="backgroundLayersExpanded"
    :accordion="accordion"
    @toggled="onToggled"
    ref="collapsible"
    :default-expanded="backgroundLayersExpanded"
    :showBackgroundLayerError="showGlobalBackgroundLayersError">
      <div v-if="layersLoading">
        <spinner class="layers-loading" :loading="true"></spinner>
      </div>
      <b-form-group v-else-if="layers.length > 0">
        <b-form-radio-group stacked v-model="selected" name="background-layers-radio" class="background-layers-group">
          <b-form-radio v-for="layer in layers" :key="layer.value" :value="layer.value">
            <span>{{ layer.text }}</span>
            <icon v-if="layer.loadError" name="exclamation-triangle" class="text-danger float-right blayer-error-icon" aria-hidden="true" title="Błąd wczytywania podkładu."></icon>
          </b-form-radio>
        </b-form-radio-group>
      </b-form-group>
      <h4 v-else class="pt-2 pb-2 text-center text-muted">
        Brak warstw
      </h4>
  </collapsible-widget>
</template>

<script>
import { mapGetters } from "vuex";
import {
  MAKE_BACKGROUND_LAYER_VISIBLE
} from "../store/actions.type";
import { BACKGROUND_LAYERS_EXPANDED_SET } from "../store/mutations.type";
import CollapsibleWidget from "./CollapsibleWidget";
import CompositionLayers from "./CompositionLayers";
import Spinner from "./Spinner";

export default {
  props: {
    accordion: {
      type: String,
      default: 'panel'
    }
  },
  components: {
    CollapsibleWidget,
    CompositionLayers,
    Spinner
  },
  data() {
    return {
      selected: null,
      layers: []
    }
  },
  computed: {
    ...mapGetters(["backgroundLayers", "readOnly", "backgroundLayersExpanded", "layersLoading"]),
    showGlobalBackgroundLayersError() {
      return Array.isArray(this.layers) && this.layers.length > 0 && this.layers.every(l => l.loadError);
    }
  },
  watch: {
    backgroundLayers: {
      handler: function(newVal) {
        if (this.layers.length === 0 && Array.isArray(newVal) && newVal.length > 0) {
          const self = this;
          
          this.layers = newVal.map(bLayer => ({ text: bLayer.title, value: bLayer.id, loadError: false, mapLayer: bLayer.mapLayer, source: bLayer.mapLayer.getSource() }));

          this.layers.forEach(layer =>  {
              layer.source.on("tileloaderror", function() {
                if (!layer.loadError) {
                  layer.loadError = true;
                  self.changeBackgroundLayer(layer.id);
                  layer.source.tileCache.expireCache();
                  layer.source.tileCache.clear();
                  layer.source.refresh({ force: true });
                }
              });
            }
          );

          this.selected = (newVal.find(x => x.visible) || newVal[0] || {}).id;
        }
      }
    },
    selected(layerId) {
      if (layerId) {
        const selectedLayer = this.layers.find(l => l.value == layerId);
        if (selectedLayer) {
          selectedLayer.loadError = false;
          this.$store.dispatch(MAKE_BACKGROUND_LAYER_VISIBLE, layerId);
        }
      }
    }
  },
  methods: {
    onToggled(expanded) {
      this.$emit("toggled", expanded);
      this.$store.commit(BACKGROUND_LAYERS_EXPANDED_SET, (expanded || {}).expanded);
    },
    changeBackgroundLayer(currentLayerId) {
      if (this.layers.length > 1) {
        const differentLayerThanCurrent = this.layers.find(l => l.value !== currentLayerId && l.loadError == false);
        if (differentLayerThanCurrent) {
          this.selected = differentLayerThanCurrent.value;
        } else { 
          this.selected = null;
        }
      }
    }
  }
};
</script>

<style>
.background-layers-group > .custom-radio {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 2rem;
}

.background-layers-group > .custom-radio:hover {
  background-color: rgba(0, 0, 0, 0.05); 
}

.background-layers-group .custom-control-label {
  width: 100%;
  cursor: pointer;
}

@keyframes fadeIn {
  50% {
    transform: scale(1.5);
  }
}

.blayer-error-icon {
  margin-top: 0.12rem;
  margin-right: 0.5rem;
  animation-name: fadeIn;
  animation-duration: 250ms;
  animation-fill-mode: forwards;
  animation-timing-function: cubic-bezier(0.0, 0.0, 0.2, 1);
}
</style>
